import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  Result,
  Statistic ,
  Form,
  DatePicker
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
// import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import "./style.css";
function Dashboard() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [form] = Form.useForm();
  const [btnloading, setbtnloading] = useState(false);
  const moduleNamePural = "Diwali Bonanza Gift Dashboard";
  const base_url = config.api_url + "admin/leads/diwali-bonanza/gift-report"; //without trailing slash
  const image_url = config.api_url + "public/uploads/diwali-bonanza/"; //with trailing slash

  // const { Link } = Anchor;
  const { RangePicker } = DatePicker;

 

  const fetchDatas = async (from=null,to=null) => {


    const url=(from && to)?`${base_url}?from=${from}&to=${to}` : base_url;

    setloading(true);
    const data = await http.get(url);

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const handleSubmit = async (value) => {

   if(value?.date_range?.length==2){
    const from=value.date_range[0].format("YYYY-MM-DD");
    const to =value.date_range[1].format("YYYY-MM-DD");
   

    setbtnloading(true);
    fetchDatas(from,to);
    setbtnloading(false);
   }
  };

  
 
  

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row gutter={15}>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Form layout="inline" form={form} onFinish={handleSubmit}>
                <Form.Item
                  label="Date Range:"
                  name="date_range"
                 
                  
                >
                  <RangePicker />
                </Form.Item>

                
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={btnloading}>
                    Filter
                  </Button>
                  
                </Form.Item>
                <Button type="primary" onClick={()=> {fetchDatas(); form.resetFields();}} >
                    Reset
                  </Button>
              </Form>

             
            </Card>
          </div>
        </Col>
      </Row>

      <div className="site-statistic-demo-card">
    <Row gutter={[16,16]} justify="center">

    {
        datas.length ?datas.map((data)=>{
          return  <Col span={8}>
          <Card>
            <Statistic
              title={data._id.label}
              value={data.count}
              
            />
          </Card>
        </Col>
        }) : <Result
        status="error"
        title="No Data Found"
       
        
      />

      }
     
      {/* <Col span={8}>
        <Card>
          <Statistic
            title="Idle"
            value={1}
           
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic
            title="Idle"
            value={1}
           
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic
            title="Idle"
            value={1}
           
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card>
          <Statistic
            title="Idle"
            value={1}
           
          />
        </Card>
      </Col> */}
    </Row>
  </div>
    </div>
  );
}

export default Dashboard;
